<template>
  <div class="plv-ia-timer-preparing">
    <div class="plv-ia-timer-preparing__main pws-vclass-timer-preparing__main plv-ia-clearfix">
      <num-panel v-model="time[0]" :max="5" />
      <num-panel v-model="time[1]" />

      <div class="plv-ia-timer-colon"></div>

      <num-panel v-model="time[2]" :max="5" />
      <num-panel v-model="time[3]" />
    </div>
    <div class="plv-ia-timer-preparing__footer">
      <div class="plv-ia-timer-preparing__footer-handler">
        <button
          class="plv-ia-timer-btn pws-vclass-btn-blue"
          :disabled="disabledBtn"
          @click="handleStart"
        >
          {{ t('plvIA.timer.start') }}
        </button>
        <div class="plv-ia-timer-preparing__checkbox">
          <form-checkbox
            :model-value="enableTimeOut"
            :value="true"
            @change="changeTimeOut"
          >
            {{ t('plvIA.timer.timeout') }}
          </form-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
import FormCheckbox from '@/components/form/Checkbox';
import NumPanel from './NumPanel.vue';

export default {
  components: {
    NumPanel,
    FormCheckbox
  },
  mixins: [Locale],

  props: {
    enableTimeOut: Boolean,
  },

  data() {
    return {
      time: [0, 5, 0, 0],
    };
  },

  computed: {
    disabledBtn() {
      return this.time.reduce((a, b) => a + b) === 0;
    }
  },

  methods: {
    handleStart() {
      const time = (this.time[0] * 10 + this.time[1]) * 60 + this.time[2] * 10 + this.time[3];
      this.$emit('start', time);
    },

    changeTimeOut(val) {
      this.$emit('change-time-out', val);
    }
  }
};
</script>

<style lang="scss">
.plv-ia-timer-preparing__main {
  padding: 16px 20px;

  >* {
    float: left;
  }
}

.plv-ia-timer-preparing__footer {
  text-align: center;
  padding-bottom: 24px;
  position: relative;
}
.plv-ia-timer-preparing__footer-handler {
  display: inline-block;
  position: relative;
}

.plv-ia-timer-preparing__checkbox {
  position: absolute;
  right: -70px;
  top: 0;

  .plv-ia-checkbox {
    padding-top: 10px;
    margin-right: 0;
  }

  .plv-ia-checkbox>input {
    height: 14px;
  }
  .plv-ia-checkbox>input+label {
    color: #E4E4E4;
    font-size: 14px;
    user-select: none;
    padding-left: 17px;
  }
  .plv-ia-checkbox>input+label:before {
    width: 14px;
    height: 14px;
    background-color: transparent;
    border-color: #E4E4E4;
  }
  .plv-ia-checkbox>input:checked+label:before {
    background-image: url(./images/icon-checked.png);
    background-color: #366BEE;
    border-color: #366BEE;
    background-size: 90%;
    background-position: top center;
  }
}
</style>
